export type AppNavSection = "me" | "friends" | "learn" | "compatibility";

/**
 * The bottom navigation is a set of pinned product areas. These prefixes are
 * the sitemap contract for those areas: child routes inherit their parent's
 * active state without each component inventing another pathname check.
 */
export const APP_NAV_PREFIXES: Record<AppNavSection, readonly string[]> = {
  me: ["/me", "/charts", "/wizard", "/library", "/home"],
  friends: ["/friends"],
  learn: ["/learn", "/hd-basics", "/centers"],
  compatibility: ["/compatibility", "/compatibility-report", "/compatibility-visual"],
};

export function isAppNavSectionActive(section: AppNavSection, pathname: string) {
  return APP_NAV_PREFIXES[section].some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
